function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9866 12.2245C23.9866 11.2413 23.9049 10.5238 23.7282 9.77966H12.2383V14.2176H18.9826C18.8467 15.3205 18.1124 16.9815 16.4807 18.0976L16.4578 18.2462L20.0907 20.9964L20.3424 21.0209C22.654 18.9347 23.9866 15.8653 23.9866 12.2245Z",
  fill: "#4285F4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2372 23.9176C15.5413 23.9176 18.3152 22.8545 20.3413 21.0209L16.4796 18.0976C15.4462 18.8018 14.0592 19.2934 12.2372 19.2934C9.00095 19.2934 6.25427 17.2074 5.27515 14.324L5.13164 14.3359L1.35409 17.1927L1.30469 17.3269C3.3171 21.2334 7.45077 23.9176 12.2372 23.9176Z",
  fill: "#34A853"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.2758 14.324C5.01745 13.5799 4.86794 12.7826 4.86794 11.9588C4.86794 11.135 5.01745 10.3378 5.26221 9.59366L5.25536 9.43519L1.43048 6.53247L1.30533 6.59064C0.47592 8.21174 0 10.0322 0 11.9588C0 13.8855 0.47592 15.7059 1.30533 17.327L5.2758 14.324Z",
  fill: "#FBBC05"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2372 4.62403C14.5351 4.62403 16.0852 5.59402 16.9691 6.40461L20.4228 3.10928C18.3017 1.1826 15.5413 0 12.2372 0C7.45077 0 3.31711 2.68406 1.30469 6.59056L5.26156 9.59359C6.25427 6.7102 9.00096 4.62403 12.2372 4.62403Z",
  fill: "#EB4335"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9866 12.2245C23.9866 11.2413 23.9049 10.5238 23.7282 9.77966H12.2383V14.2176H18.9826C18.8467 15.3205 18.1124 16.9815 16.4807 18.0976L16.4578 18.2462L20.0907 20.9964L20.3424 21.0209C22.654 18.9347 23.9866 15.8653 23.9866 12.2245Z",
  fill: "#4285F4"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2372 23.9176C15.5413 23.9176 18.3152 22.8545 20.3413 21.0209L16.4796 18.0976C15.4462 18.8018 14.0592 19.2934 12.2372 19.2934C9.00095 19.2934 6.25427 17.2074 5.27515 14.324L5.13164 14.3359L1.35409 17.1927L1.30469 17.3269C3.3171 21.2334 7.45077 23.9176 12.2372 23.9176Z",
  fill: "#34A853"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M5.2758 14.324C5.01745 13.5799 4.86794 12.7826 4.86794 11.9588C4.86794 11.135 5.01745 10.3378 5.26221 9.59366L5.25536 9.43519L1.43048 6.53247L1.30533 6.59064C0.47592 8.21174 0 10.0322 0 11.9588C0 13.8855 0.47592 15.7059 1.30533 17.327L5.2758 14.324Z",
  fill: "#FBBC05"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2372 4.62403C14.5351 4.62403 16.0852 5.59402 16.9691 6.40461L20.4228 3.10928C18.3017 1.1826 15.5413 0 12.2372 0C7.45077 0 3.31711 2.68406 1.30469 6.59056L5.26156 9.59359C6.25427 6.7102 9.00096 4.62403 12.2372 4.62403Z",
  fill: "#EB4335"
});

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.4334cb4a.svg";
export { ForwardRef as ReactComponent };